import React, { useEffect, useState } from "react";
import Setup from "./Setup";
import Settings from "./Settings";
import AiTeammateDetails from "../AiTeammateDetails";
import { useSearchParams } from "react-router-dom";

const EmailOrderProcessing = () => {
      const [searchParams] = useSearchParams();
      const currTab = searchParams.get("currTab");

    const [activeTab, setActiveTab] = useState(currTab ? Number(currTab) : 0);

    const displayActiveTab = () => {
        switch (activeTab) {
            case 0:
                return <Setup setActiveTab={setActiveTab} activeTab={activeTab} />;
            case 1:
                return <AiTeammateDetails setOverviewTab={setActiveTab} overviewTab={activeTab} />;
            // return <Tasks setActiveTab={setActiveTab} activeTab={activeTab} />;
            case 2:
                return <Settings setActiveTab={setActiveTab} activeTab={activeTab} />;
            default:
                return <Setup setActiveTab={setActiveTab} activeTab={activeTab} />;
        }
    };
    return (
        <div className="border border-slate-100 rounded-[8px] bg-white">{displayActiveTab()}</div>
    );
};

export default EmailOrderProcessing;
